export const parseTokenPermissions = (token: string): string[] => {
    const tokenPayload = token.split('.')[1];
    const base64Decoded = window.atob(tokenPayload);
    const payload = JSON.parse(base64Decoded);
    return payload.permissions ?? [];
}